import { getUserMembership, getUserPricingPlans, postPayment } from './Services';

export const SERVICES = {
  getUserMembership,
  getUserPricingPlans,
  postPayment,
};
